import type {DefaultOptions} from '../../../types';
import type {NumberRangeValueEditorLocalizations, NumberRangeValueEditorModel} from './types';
import type {ValueEditorOptions} from '../../../kp-value-editor/types';
import {isEqual} from 'lodash-es';
import {isNullOrUndefined} from '../../../../utils/custom-utils';

/**
 * @ngdoc constant
 * @name NUMBER_RANGE_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module  portaro.value-editors.number-range
 *
 * ```javascript
 * {
 *      customEmptyAsNullCheck: ({value}: {value: NumberRangeValueEditorModel}) => value === undefined || value === null || isEqual(value, {}) || isEqual(value, EMPTY_MODEL)
 * }
 * ```
 */
export const NUMBER_RANGE_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<ValueEditorOptions> = {
    customEmptyAsNullCheck: ({value}: {value: NumberRangeValueEditorModel}) => isNullOrUndefined(value) || isEqual(value, {}) || isEqual(value, EMPTY_MODEL)
};


export const EMPTY_MODEL: NumberRangeValueEditorModel = {
    from: 0,
    to: 0
};

/**
 * @ngdoc constant
 * @name NUMBER_RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.number-range
 *
 * @description
 * ```
 * {
 *      description: '',
 *      from: 'From',
 *      to: 'To'
 * }
 * ```
 */
export const NUMBER_RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<NumberRangeValueEditorLocalizations>({
    description: '',
    from: 'From',
    to: 'To'
});
